import { useQuery } from 'react-query';
import { QueryKey } from '@behavior/QueryKey';
import { getDistributionListPreFill } from './api';
import { LocationDTO } from '@behavior/inventories/dto/LocationDTO';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';

export default function useDistributionListPreFill(locations: LocationDTO[]) {
  if (locations.length === 0) {
    return { distributionListPreFillPersons: [], isLoading: false };
  }

  const { data: distributionListPreFillPersons, isLoading } = useQuery<ContactDTO[]>(
    [QueryKey.DISTRIBUTION_LIST_PREFILL],
    () => getDistributionListPreFill(locations)
  );

  return { distributionListPreFillPersons, isLoading };
}
